import React, {useState} from "react";
import { AppDispatch } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { deleteSpa } from "../../../redux/actions/spa.actions";
import { useSearchParams } from "react-router-dom";
import { ModalProps } from "../Interfaces/Modals";
import RootState from "../../../redux/states/root.state";
import ModalShell, { ModalLoading } from "./ModalShell";
import { clearError } from "../../../redux/reducers/spa.reducer";

const DeleteSpaModal: React.FC<ModalProps> = ({open, setOpen, object}) => {
  const spa = object;

  const {loading: spaLoading, error: spaError} = useSelector((state: RootState) => state.spa);
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];

  const [submitted,setSubmitted] = useState(false);
  // Only reflect this modal's own request, not the page's fetches on the same slice.
  const loading = submitted && spaLoading;
  const error = submitted ? spaError : null;

  const handleClose = () => {
    dispatch(clearError());
    setSubmitted(false);
    setOpen(false);
  };

  const handleDelete = async () => {
    setSubmitted(true);
    await dispatch(deleteSpa({guid:spa?.id, params:searchParams.toString()}));
  }

  const busy = !error && Boolean(loading);

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={busy}
      tone={error ? "error" : busy ? undefined : submitted ? "success" : "warning"}
      title={
        error ? "An error occurred"
        : busy ? "Deleting…"
        : submitted ? "Spa deleted"
        : <>Delete spa <strong>{spa?.nick_name}</strong>?</>
      }
      actions={busy ? undefined : error || submitted ?
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
        :
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
        </>
      }
    >
      {error ?
        <p>An error occurred while deleting, please try again later.</p>
        : busy ?
        <ModalLoading/>
        : submitted ?
        <p>Spa successfully deleted.</p>
        :
        <p>This action cannot be undone.</p>
      }
    </ModalShell>
  );
};

export default DeleteSpaModal;
